<template>
	<v-container>
		<v-card outlined>
			<v-card-title v-text="$ml.get('user_tracking')" class="justify-center pa-0 body-2 caption blue-grey lighten-1" ></v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-simple-table dense>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-center"> {{$ml.get('id')}}</th>
								<th class="text-center"> {{$ml.get('username')}}</th>
								<th class="text-center"> {{$ml.get('date_in')}}</th>
								<th class="text-center"> {{$ml.get('date_out')}}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="text-center"></td>
								<td class="text-center"></td>
								<td class="text-center"></td>
								<td class="text-center"></td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
	export default{
		name: 'user_tracking',
		data: () => ({

		}),
	}
</script>